import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { Box, Dialog, DialogContent, Divider, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import React, { useState } from 'react';

import { MedicalTileProps } from './MedicalMeasures.types';
import i18n from 'FRONTEND/utils/i18n';

const colorMap = {
  blood_pressure: '#FF7E45',
  temperature: '#9057AA',
  oximetry: '#97B2DC',
  glucose: '#DD554D',
  ecg: '#8ED5BD',
  other_medical_measurement: '#7B8794',
};

const MedicalTile = ({ type, deviceName, measureData, notes, consultationDate, measureDate, imageSrc, fileLink, fileName, site, context, category }: MedicalTileProps) => {
  const [open, setOpen] = useState(false);

  const isSameDay = dayjs(measureDate).isSame(consultationDate, 'day');
  const formattedDate = isSameDay ? dayjs.utc(measureDate).local().format('LT') : dayjs.utc(measureDate).local().format('LLL');

  const content = measureData.map((measure, index) => measure?.value && (
    <div className='md__measure' key={measure.label || index}>
      <div className='measure__label'>{measure.label}</div>
      <div className='measure__value'>
        <div>{measure.value}</div>
        <div className='measure__unit'>{measure.unit}</div>
      </div>
    </div>
  ));

  return (content.length || imageSrc || fileLink) ? (
    <div>
      <Divider sx={{ mx: 2 }} />
      <Stack direction='row' spacing={1} p={1}>
        <Stack direction='row' bgcolor={(theme) => theme.palette.grey[500]} borderRadius={15} px={0.8} alignItems='center'>
          <AccessTimeFilledIcon sx={{ fontSize: 22, color: 'white', pr: '3px' }} />
          <Typography color='white'>{formattedDate}</Typography>
        </Stack>
        {deviceName && <Typography bgcolor={colorMap[type]} borderRadius={15} px={1} sx={{ color: 'white' }}>{deviceName}</Typography>}
        {category && <div className='md__category'>{category}</div>}
      </Stack>
      {content.length ? (
        <div className='md__content'>
          {content}
        </div>
      ) : null}
      <Box p={1}>
        {site && (
          <div className='md__details'>
            <span className='md__detailsLabel'>{i18n._('Site')}</span>
            {site}
          </div>
        )}
        {context && (
          <div className='md__details'>
            <span className='md__detailsLabel'>{i18n._('Context')}</span>
            {context}
          </div>
        )}
        {notes && (
          <div className='md__details'>
            <span className='md__detailsLabel'>{i18n._('Notes')}</span>
            {notes}
          </div>
        )}
      </Box>
      {imageSrc && (
        <div className='md__imageThumbnailContainer'>
          <img className='md__imageThumbnail' src={imageSrc} onClick={() => setOpen(true)} />
          <Dialog
            open={open}
            onClose={() => setOpen(false)}
            maxWidth={false}
          >
            <DialogContent className='md__imageContainer'>
              <img className='md__image' src={imageSrc} />
            </DialogContent>
          </Dialog>
        </div>
      )}
      {fileLink && (
        <Box p={1}>
          <a href={fileLink} target='_blank' rel='noreferrer' className='md__fileLink'>
            <InsertDriveFileIcon sx={{ verticalAlign: 'middle', mr: 0.5 }} fontSize='small' />
            {fileName || i18n._('View file')}
          </a>
        </Box>
      )}
    </div>
  ) : null;
};

export default MedicalTile;
